/* Fortune Food: compact header (logo shrinks on scroll) + Smile rewards integration */
(function () {
  if (window.__ffHeader) return;
  window.__ffHeader = true;

  var css =
    '.site-header__logo a,.header-item--logo{transition:width .25s ease,flex-basis .25s ease}' +
    '.site-header{transition:padding .25s ease}' +
    'body.ff-scrolled .header-item--logo{flex:0 1 56px!important}' +
    'body.ff-scrolled .site-header__logo a,body.ff-scrolled .is-light .site-header__logo .logo--inverted{width:56px!important}' +
    'body.ff-scrolled .site-header__logo img{max-width:56px!important;max-height:56px!important}' +
    'body.ff-scrolled .site-header{padding-top:4px!important;padding-bottom:4px!important}' +
    'body.ff-scrolled .site-header .site-nav__link--icon{padding-top:6px;padding-bottom:6px}' +
    '@media only screen and (min-width:769px){' +
      'body.ff-scrolled .header-item--logo{flex:0 0 64px!important}' +
      'body.ff-scrolled .site-header__logo a,body.ff-scrolled .is-light .site-header__logo .logo--inverted{width:64px!important}' +
      'body.ff-scrolled .site-header__logo img{max-width:64px!important;max-height:64px!important}' +
    '}' +
    '@media (prefers-reduced-motion:reduce){.site-header__logo a,.header-item--logo,.site-header{transition:none}}' +
    /* Smile: hide only the floating launcher button; the rewards panel still opens from the header Rewards icon */
    '#smile-ui-lite-launcher-frame-container,#smile-ui-launcher-frame-container,.smile-launcher-frame-container{display:none!important}' +
    '.ff-rewards-link .icon-gift{fill:none}' +
    '.ff-points{display:flex;align-items:center;gap:6px;margin:0 0 12px;font-size:.88em;color:#7a4f00}' +
    '.ff-points a{text-decoration:underline;color:inherit}';
  var st = document.createElement('style');
  st.textContent = css;
  (document.head || document.documentElement).appendChild(st);

  /* ---- Logo shrink on scroll ---- */
  var scrolled = false;
  var ticking = false;
  function update() {
    ticking = false;
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    if (!scrolled && y > 120) {
      scrolled = true;
      document.body.classList.add('ff-scrolled');
    } else if (scrolled && y < 40) {
      scrolled = false;
      document.body.classList.remove('ff-scrolled');
    }
  }
  window.addEventListener('scroll', function () {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(update);
    }
  }, { passive: true });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', update);
  } else {
    update();
  }

  /* ---- Smile: open the rewards panel from any #smile-... link (header Rewards icon, cart, product page) ---- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href^="#smile-"]');
    if (!a) return;
    var ui = window.SmileUI;
    if (ui && typeof ui.openPanel === 'function') {
      e.preventDefault();
      var deep = a.getAttribute('href').replace('#smile-', '');
      try {
        if (deep && deep !== 'home') { ui.openPanel({ deep_link: deep }); } else { ui.openPanel(); }
      } catch (err) {
        try { ui.openPanel(); } catch (err2) { window.location.hash = a.getAttribute('href'); }
      }
    }
    /* If Smile's script hasn't loaded yet, the #smile-home link is left to Smile's own deep-link handling */
  });
  /* ---- 4 Nov 1:47 PM (Rae): Grab-style mobile header. Under 990px, on pages with the sticky browse bar, the stuck logo row
     slides up on scroll down (the bar then pins to the very top) and slides back on scroll up. Desktop unchanged. ---- */
  (function () {
    var mq = window.matchMedia ? window.matchMedia('(max-width:989px)') : null;
    var st2 = document.createElement('style');
    st2.textContent = '@media (max-width:989px){#SiteHeader.site-header--stuck{transition:transform .22s ease}' +
      'body.ff-hdr-hide #SiteHeader.site-header--stuck{transform:translateY(-100%)!important;box-shadow:none!important}}' +
      '@media (prefers-reduced-motion:reduce){#SiteHeader.site-header--stuck{transition:none!important}}';
    (document.head || document.documentElement).appendChild(st2);
    var lastY = window.pageYOffset || 0, hidden = false, acc = 0;
    function follow() { /* keep the browse bar glued to the header's bottom edge while it slides */
      var t0 = Date.now();
      (function step() { if (window.__ffcnFrame) window.__ffcnFrame(); if (Date.now() - t0 < 300) requestAnimationFrame(step); })();
    }
    function set(h) { if (h === hidden) return; hidden = h; document.body.classList.toggle('ff-hdr-hide', h); follow(); }
    function busy() { var c = (document.documentElement.className + ' ' + document.body.className); return /drawer-open|js-drawer-open|ffd-lock|overflow-hidden|ffdd-open/.test(c); }
    function tick() {
      var y = window.pageYOffset || document.documentElement.scrollTop || 0, d = y - lastY; lastY = y;
      var sh = document.getElementById('SiteHeader');
      if (!mq || !mq.matches || !document.querySelector('[data-ffcn-bar]') || !sh) { set(false); return; }
      if (window.__ffJumping) return; /* a dropdown / hash jump keeps the current state, so its offsets stay right */
      if (busy()) return;
      if (y <= (sh.offsetHeight || 80) || !sh.classList.contains('site-header--stuck')) { acc = 0; set(false); return; }
      if ((d > 0) !== (acc > 0)) acc = 0; acc += d;
      if (acc > 12) set(true); else if (acc < -12) set(false);
    }
    var tk = false;
    window.addEventListener('scroll', function () { if (!tk) { tk = true; requestAnimationFrame(function () { tk = false; tick(); }); } }, { passive: true });
    if (mq && mq.addEventListener) mq.addEventListener('change', function () { if (!mq.matches) set(false); });
  })();
})();
